var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 44,
    viewBox: "0 0 37 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6496 15.0118L24.4706 22.6889M16.6496 15.0118C12.7496 15.0118 4.53658 15.0118 2.8848 15.0118C1.23301 15.0118 0.945202 16.0937 1.00777 16.6346C1.00777 23.8124 1.00777 38.6172 1.00777 40.4148C1.00777 42.2124 2.25912 42.6201 2.8848 42.5993C9.22497 42.5993 21.347 42.5993 22.3981 42.5993C23.9075 42.5993 24.4706 41.7879 24.4706 40.4148V22.6889M16.6496 15.0118C16.6496 16.1145 16.6496 18.7443 16.6496 20.442C16.6496 22.1396 18.1096 22.6473 18.8395 22.6889H24.4706M5.82546 24.7486H13.1459M5.82546 29.4922H16.6496M5.82546 34.2357H19.5277",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1789 1.01172L35.9999 8.68879M28.1789 1.01172C24.2789 1.01172 16.0659 1.01172 14.4141 1.01172C12.7623 1.01172 12.4745 2.09358 12.5371 2.63451C12.5371 4.77017 12.5371 6.19413 12.5371 7.1882C12.5371 8.18639 12.5371 9.07539 12.5371 9.86467C12.5371 10.9311 12.5371 10.2743 12.5371 11M28.1789 1.01172C28.1789 2.11439 28.1789 4.74415 28.1789 6.44184C28.1789 8.13954 29.6388 8.64718 30.3688 8.68879H35.9999M35.9999 8.68879V26.4147C35.9999 27.7879 35.4368 28.5992 33.9274 28.5992C33.6076 28.5992 32.2633 28.5992 30.3688 28.5992C29.3586 28.5992 29.43 28.5992 28.1789 28.5992M17.3548 10.7485H24.6752M23.5 15.492L28.1789 15.4921M27.8235 20.2356L31.057 20.2356",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventory-icon.0ff4981732f8c8ff9e8a071087aebb3f.svg";
export { ForwardRef as ReactComponent };